import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

// import { OrdersComponent } from 'src/app/sections/orders/orders.component';

import { SharedModuleModule } from "../shared-module/shared-module.module";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { MaterialModule } from "../material/material.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DataTablesModule } from "angular-datatables";
import { OrdersRoutingModule } from "./orders-routing";
import { OrdersComponent } from "../../sections/orders/orders.component";

@NgModule({
  declarations: [OrdersComponent],
  imports: [
    CommonModule,
    SharedModuleModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    OrdersRoutingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    DataTablesModule,
  ],
  exports: [],
  providers: [],
})
export class OrdersModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
